module.exports = __webpack_public_path__ + "food.svg?7e09a835ad5d4984f2d45b1684021579";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badges/food.svg
// module id = 90
// module chunks = 0